module.exports = __webpack_public_path__ + "media/flags/ch-cd82f1bd.svg";